export default "__VITE_ASSET__B2t4gZjS__"